"use client";

import { ActivityDisplayPreview } from "./previews";

type AnimalFlowDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function AnimalFlowDisplay({
  data,
  participants,
}: AnimalFlowDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="animal-flow"
      data={data}
      participants={participants}
    />
  );
}
